import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetAllFlaggedPhoneNumbers = () => {
  const get = useTypedApiClient({
    path: '/admin/flaggedPhoneNumbers',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/flaggedPhoneNumbers'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
